import {Badge} from "react-bootstrap";
import {Trace} from "@models/trace.model.ts";
import traceStore from "../../../traceStore.ts";

import styles from "../../../tracer.module.css";
import {Button} from "@mui/material";


interface TraceRowProps {
  trace: Trace
}
export const TraceRow = (props:TraceRowProps) => {

    function handleView() {
        traceStore.selectedTraceId = props.trace.id;
    }

    function determineRequestColor() {

        if (props.trace.http_method === 'GET') return 'success';
        if (props.trace.http_method === 'POST') return 'primary';
        if (props.trace.http_method === 'PUT') return 'warning';
        if (props.trace.http_method === 'DELETE') return 'danger';

        return 'success';
    }

    return (

        <tr className="border-b border-gray-100 hover:bg-gray-50 transition-colors" key={props.trace.id}>
            <td className="px-6 py-2 text-sm text-gray-700">{props.trace.user.employee.person.first_name} {props.trace.user.employee.person.last_name}</td>
            <td className="px-6 py-2">
                <Badge pill
                       bg={determineRequestColor()}
                       className={`${styles.badgeFixed}`}
                >
                    {props.trace.http_method}
                </Badge>
                <code className="text-sm text-gray-7 bg-gray-100 px-2 py-1 rounded font-mono">
                    {props.trace.url}
                </code>
            </td>
            <td className="px-6 py-2">
                <Badge pill
                    bg={props.trace.status === "Success" ? "success" : "danger"}
                    className={`${styles.badgeFixed} badge`}
                >
                    {props.trace.status}
                </Badge>
            </td>
            <td className="px-6 py-2 text-sm text-gray-600 font-mono text-center">{props.trace.duration} ms</td>
            <td className="px-6 text-center">
                <Button onClick={handleView}>
                        <i className="bi bi-eye-fill text-muted fs-16"/>

                </Button>
            </td>
        </tr>

    );
};

